export default __webpack_public_path__ + "static/media/storm.94ae1a1f.png";